import React ,{useState} from 'react';
import ButtonSection from '../components/button-section';
import logo from "../img/logo-bleu.webp";

export default function Demandeur (props) {
	const [dataValid , setDataValid] =  useState(false);
	const [errors , setErrors] = useState([]);
	const [age , setAge] = useState('');
	const {step , restart  , simulationData} = props;

	const goToNextStep = ()=>{
		if (dataValid){
			props.updateData( 'demandeur' , {age : age});
			props.nextStep()
		} else {
			let error = [];
			if (age ===''){
				error.push('Veuillez renseigner votre âge.');
			} else if (isNaN(age)) {
				error.push ('Veuillez renseigner un âge valide.');
			}
			setErrors(error);
		}
	};

	const changeAge = (e)=>{
		let newValue = parseInt(e.target.value);
		setDataValid(!isNaN(newValue));
		setAge(newValue);
	}

	return <div id="demandeur" className="sim-form min-height" >

		<div className="container">
			<div className="question-set">
				<div className="question">
					<label> Quel est votre âge ?</label>
				</div>
				<div className="input">
					<input type="number"
						className="form-control"
						onChange={changeAge}
						placeholder="Ex: 25"
					/>
					<span className="unit">an.s</span>
				</div>

			</div>
			
		</div>
		<ButtonSection
			restart={restart}
			action={goToNextStep}
			dataValid= {dataValid}
			errors={errors}
			data={simulationData}
			step = {step}
		> 
		</ButtonSection>
	<div className="site-address pt-3 pt-sm-0">
      <div className="col">
        <img src={logo} alt="logo aide-sociale.fr"/>
      </div>
    </div>
	</div>
}